<template>
  <div>
    <b-card no-body class="my-2">
      <b-row>
        <b-col cols="12" md="3">
          <clazy-load :src="hotel.imagen" :id="`cl-img-htl-${idhotel}`" @error="errorLoad" class="cont-img-hotel">
            <b-img :src="hotel.imagen" fluid-grow alt="Imagen Hotel" class="cover" :id="`img-htl-${idhotel}`" />
            <div class="preloader" slot="placeholder">
              <div class="d-flex justify-content-center mb-3 mt-30-as">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
            </div>
          </clazy-load>
        </b-col>
        <b-col cols="12" md="6" class="py-2">
          <p class="text-center text-md-left mb-0">
            <strong>{{ hotel.nombre.toUpperCase() }}</strong>
          </p>
          <p class="text-muted text-center text-md-left mb-0">
            <small>{{ hotel.direccion }}</small>
          </p>
          <p
            class="text-center text-md-left mb-0"
            v-if="toInteger(hotel.categoria) > 0 && toInteger(hotel.categoria) < 6"
          >
            <v-icon
              class="hotel-star"
              v-for="(c, index) in toInteger(hotel.categoria)"
              :key="index"
              small
              color="orange"
              >fas fa-star</v-icon
            >
          </p>
          <p class="text-center text-md-left mb-0 caption text-muted" v-else>
            {{ getNombreCategoria(hotel.categoria) }}
          </p>
          <p class="text-muted text-center text-md-left mb-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  v-if="hotel.latitud"
                  color="grey lighten-1"
                  dark
                  small
                  class="cur-pointer"
                  @click="verm = !verm"
                  >fas fa-map-marker</v-icon
                >
              </template>
              <span>Ver mapa</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  v-if="hotel.url"
                  color="grey lighten-1"
                  dark
                  small
                  class="cur-pointer ml-1"
                  @click="_$goToUrl(hotel.url)"
                  >fas fa-globe</v-icon
                >
              </template>
              <span>Web</span>
            </v-tooltip>
          </p>
        </b-col>
        <b-col cols="12" md="3" class="py-2 text-center" v-if="disponible">
          <p class="color-red-as text-center">
            <small>Habitaciones desde:</small>
          </p>
          <p class="color-red-as text-center title">
            <strong>{{ hotel.moneda }} {{ hotel.masEconomico }}</strong>
          </p>
          <div class="px-2">
            <v-btn small color="primary" block data-cy="verMasHabi" @click="showCollapse = !showCollapse"
              >Ver más</v-btn
            >
          </div>
        </b-col>
        <b-col cols="12" md="3" class="py-2 text-center" v-else>
          <v-container fluid class="text-xs-center">
            <v-layout flex justify-space-between wrap>
              <v-flex xs12>
                <p class="grey--text lighten-1">Sin disponibilidad</p>
              </v-flex>

              <v-flex xs12>
                <v-tooltip v-model="showToolTip" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon color="grey lighten-1" @click="openModalConsulta">fas fa-envelope-square</v-icon>
                    </v-btn>
                  </template>
                  <span>Consultar</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-container>
        </b-col>
        <b-col cols="12" v-if="verm">
          <Mapa
            :lat="hotel.latitud"
            :lng="hotel.longitud"
            width="100%"
            height="323px"
            :platformHere="platformHere"
          ></Mapa>
        </b-col>
        <b-col cols="12">
          <b-collapse :id="'collapse-' + idhotel" v-model="showCollapse" class="mt-2">
            <PanelHabitaciones :data="hotel" v-if="showCollapse"></PanelHabitaciones>
          </b-collapse>
        </b-col>
      </b-row>
    </b-card>
    <v-dialog v-model="formConsulta" max-width="500" v-if="formConsulta">
      <v-card>
        <v-card-title class="headline">Consultanos</v-card-title>

        <v-card-text>
          <p>Hotel: {{ hotel.nombre.toUpperCase() }}</p>
          <p>
            Estadia: {{ request.checkin | formatDMY }} al
            {{ request.checkout | formatDMY }}
          </p>
          <p>Ocupación: {{ armarOcupacion() }}</p>
          <v-form>
            <v-container>
              <v-layout>
                <v-flex xs12>
                  <v-textarea
                    name="observacion"
                    label="Observación"
                    v-model="observacion"
                    hint="Hint text"
                    no-resize
                    height="50px"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-alert v-model="enviado.is" dismissible :type="enviado.context">{{ enviado.mensaje }}</v-alert>
        </v-card-text>

        <v-card-actions v-if="!enviado.is">
          <v-btn color="red darken-4" class="text-white" @click="formConsulta = false">
            <v-progress-circular indeterminate color="white" size="20" v-if="enviando"></v-progress-circular>
            <span v-if="!enviando">Cerrar</span>
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn class="text-white" color="red darken-4" @click="enviar">
            <v-progress-circular indeterminate color="white" size="20" v-if="enviando"></v-progress-circular>
            <span v-if="!enviando">Enviar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex"
import Loading from "@/components/utiles/Loading.vue"
import AxiosHandler from "@/assets/js/class/AxiosHandler.js"
const Mapa = () => ({
  component: import("@/components/utiles/Mapa.vue")
  //loading: AwesomeSpinner
})
const PanelHabitaciones = () => ({
  // The component to load (should be a Promise)
  component: import("@/components/hoteles/PanelHabitaciones.vue"),
  // A component to use while the async component is loading
  loading: Loading,
  // A component to use if the load fails
  // error: ErrorComponent,
  // Delay before showing the loading component. Default: 200ms.
  delay: 1,
  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
  timeout: 3000
})
export default {
  name: "panelHotel",
  props: {
    hotel: {
      type: Object,
      required: true
    },
    platformHere: {
      type: Object,
      required: false
    },
    disponible: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Mapa,
    PanelHabitaciones
  },
  mounted() {
    this.idhotel = this.hotel["@attributes"].id
  },
  beforeCreate() {},
  methods: {
    toInteger(valor) {
      return parseInt(valor)
    },
    getNombreCategoria(valor) {
      const valorInt = parseInt(valor)
      if (valor == 0) {
        return "Categoria no especificada"
      }
      let nombre = null
      try {
        nombre = this.formConfig.categorias.find(ct => {
          if (ct.alt === valor) {
            return true
          }
          if (ct.value === valorInt) {
            return true
          }
          return false
        }).text
      } catch (e) {
        console.log(valor)
        console.log(e)
      }
      return nombre
    },
    errorLoad() {
      const myNode = document.getElementById(`cl-img-htl-${this.idhotel}`)
      myNode.innerHTML = `<img src="https://www.allseasons.tur.ar/ws/utiles/img/iconos/not-found.jpg" class="cover img-fluid w-100">`
    },
    openModalConsulta() {
      this.formConsulta = true
    },
    armarOcupacion() {
      let _this = this
      let s = this.request.habitaciones.map(h => {
        let stringMenores = _this.toStringMenores(h.menores.edades)
        return `${h.adl} adultos ${stringMenores}`
      })
      return s.join(", ")
    },
    toStringMenores(arMenores) {
      if (arMenores === undefined) {
        return ""
      }
      if (Array.isArray(arMenores)) {
        return "+ Menores " + arMenores.toString() + " año/s"
      }
      return "+ Menor " + arMenores + " año/s"
    },
    async enviar() {
      this.enviando = true
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }
      let axios = new AxiosHandler()
      axios.setPassportHandler(this.$passporthandler)
      const rq = {
        hotel: this.hotel,
        busqueda: {
          checkin: this.request.checkin,
          checkout: this.request.checkout,
          ocupacion: this.armarOcupacion()
        },
        observacion: this.observacion,
        contacto: this.usuario
      }
      axios.prepare(process.env.VUE_APP_ASBACK + "/api/enviar-consulta", header, rq)
      axios.overlay(false)
      await axios.exe()
      this.enviando = false
      const mensaje =
        axios.getData().enviado === 200
          ? "Su consulta fue enviada"
          : "Ocurrio un error enviando la consulta, por favor intente nuevamente."
      const context = axios.getData().enviado === 200 ? "success" : "error"
      this.enviado = {
        is: true,
        status: axios.getData().enviado,
        mensaje: mensaje,
        context: context
      }
    }
  },
  data() {
    return {
      idhotel: null,
      verm: false,
      showCollapse: false,
      showToolTip: false,
      formConsulta: false,
      observacion: null,
      enviando: false,
      enviado: { is: false, status: null, mensaje: null }
    }
  },
  computed: {
    ...mapGetters("app", {
      formConfig: "getFormConfigHtl"
    }),
    ...mapGetters("filtroHoteles", {
      request: "getRq"
    }),
    ...mapGetters("app", {
      usuario: "getUsuario"
    })
  }
}
</script>
<style scoped>
.mt-30-as {
  margin-top: 30px;
}
.cont-img-hotel {
  height: 150px;
  width: 100%;
  overflow: hidden;
}
</style>
